import { constants, getFromLocalStorage } from './localStorage';

const appDir = (): string => {
  const lang = getFromLocalStorage(constants.language);
  return lang === 'en' ? 'ltr' : 'rtl';
};

export { appDir };
